module.exports = __webpack_public_path__ + "img/es-box4-text-light.8ef7744d.png";